module.exports = __webpack_public_path__ + "static/img/img-login.59d2eba5.png";